export type { IRoute } from '@api/home/types'

export {
  Progresser,
  HomeBase,
  TransitionHoc,
  mapRoutes,
  ElementEnhance
} from '@api/home/utils'

/**
 * root根路径用于 usenavigate 跳转
 */
export const routesPath = {
  home: '/',
  collection: '/collection', // 暂无
  category: '/collection/c',
  custom: '/collection/s', // 暂无
  new: '/new',
  hot: '/hot',
  flashDeal: '/flashDeal',
  search: '/search',
  custompro: '/custompro',
  bestSellers: '/best-sellers',
  product: '/products',
  activity: '/activity',
  cart: '/cart',
  checkout: '/checkout',
  statement: '/statement',
  user: '/user', // 暂无
  order: '/order', // user子级
  password: '/user/password',
  trackOrder: '/track',
  trackOrderDetail: '/trackDetail',
  articleDetail: '/article',
  aboutHernest: '/about-hernest',
  productCare: '/product-care',
  sustainability: '/sustainability',
  affiliateProgram: '/affiliate-program',
  whyUs: '/why-us',
  contactUs: '/help',
  ourStory: '/our-story',
  simplifiedProcess: '/simplified-process',
  warehouseDelivery: '/warehouse-delivery',
  item: '/item',
  categoryEntry: '/categoryEntry',
  login: '/login',
  quickView: '/quickView',
  redwall: '/ugc-gallery',
  blog: '/blog-list',
  blogDetail: '/blog-detail',
  roomIdeas: '/room-ideas',
  favorites: '/favorites',
  allRoundExcellence: '/all-round-excellence',
  // 以下为系列页
  starrySky: '/starry-sky',
  bareniaLeather: '/barenia-leather',
  midCentury: '/mid-century-style',
  minimalist: '/minimalist-style',
  quatrefoilCollection: '/quatrefoil-collection',
  cascade: '/cascade',
  cascadeCollection: '/cascade-collection',
  heliosSunlit: '/helios-sunlit-collection',
  arcadia: '/arcadia-collection',
  paymentWaiting: '/payment-waiting'
} as const

const mRouteBak = {
  home: '/',
  collection: '/collection', // 暂无
  category: '/collection/c',
  categoryEntry: '/categoryEntry',
  custom: '/collection/s',
  new: '/new',
  hot: '/hot',
  flashDeal: '/flashDeal',
  search: '/search',
  custompro: '/custompro',
  bestSellers: '/best-sellers',
  product: '/products',
  activity: '/activity',
  cart: '/cart',
  checkout: '/checkout',
  statement: '/statement',
  login: '/login',
  user: '/user', // 个人中心
  order: '/order', // user子级
  password: '/user/password',
  trackOrder: '/track',
  trackOrderDetail: '/trackDetail',
  articleDetail: '/article',
  aboutHernest: '/about-hernest',
  productCare: '/product-care',
  sustainability: '/sustainability',
  affiliateProgram: '/affiliate-program',
  whyUs: '/why-us',
  contactUs: '/help',
  ourStory: '/our-story',
  item: '/item',
  roomIdeas: '/room-ideas',
  favorites: '/favorites',
  // 以下为系列页
  starrySky: '/starry-sky',
  bareniaLeather: '/barenia-leather',
  midCentury: '/mid-century-style',
  minimalist: '/minimalist-style',
  quatrefoilCollection: '/quatrefoil-collection',
  cascade: '/cascade',
  cascadeCollection: '/cascade-collection',
  heliosSunlit: '/helios-sunlit-collection',
  arcadia: '/arcadia-collection'
}
